var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.5H4.58333H19.25",
    stroke: "#F64A4A",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 5.50016V18.3335C17.4168 18.8197 17.2237 19.286 16.8799 19.6299C16.536 19.9737 16.0697 20.1668 15.5835 20.1668H6.41683C5.9306 20.1668 5.46428 19.9737 5.12047 19.6299C4.77665 19.286 4.5835 18.8197 4.5835 18.3335V5.50016M7.3335 5.50016V3.66683C7.3335 3.1806 7.52665 2.71428 7.87047 2.37047C8.21428 2.02665 8.6806 1.8335 9.16683 1.8335H12.8335C13.3197 1.8335 13.786 2.02665 14.1299 2.37047C14.4737 2.71428 14.6668 3.1806 14.6668 3.66683V5.50016",
    stroke: "#F64A4A",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 10.0835V15.5835",
    stroke: "#F64A4A",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 10.0835V15.5835",
    stroke: "#F64A4A",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.90bb3e158f5b8c7be1d4385034801ce2.svg";
export { ForwardRef as ReactComponent };